module.exports = __webpack_public_path__ + "media/packs/images/partners/tabletocki-e80905d5fa3e499331bb34049d569269.jpg";